import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleContactClick } from '../Components/Header';

const AboutUs = () => {


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gray-50"></div>
        <div className="absolute inset-0 bg-[#6c32ee] opacity-5 transform -skew-y-6"></div>
        <div className="relative max-w-6xl mx-auto px-8 py-32">
          <span className="inline-block text-[#6c32ee] text-sm font-semibold tracking-wider uppercase mb-6">
            Welcome to Stack - The Learners way
          </span>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-8 leading-tight">
            We Create Digital Excellence -
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e2228c] to-[#7b45ef]">
              We make Learning Fun !
            </span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl leading-relaxed">
            Transforming businesses through our expert services and products and Helping learners learn new skill in a fun way.
          </p>
        </div>
      </div>

      {/* Values Section */}
      <div className=" py-12">
        <div className="max-w-6xl mx-auto px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
            About Stack
          </h2>
          <p className="text-lg text-gray-700 mb-4 leading-relaxed">
            At Stack, we believe in learning for the love of it. While many pursue skills like coding and design to land their dream job, we emphasize that these skills can be just as enjoyable as playing a game of cricket—where it's not just about winning, but about the joy of the game itself.
          </p>
          <p className="text-lg text-gray-700 mb-4 leading-relaxed">
            Our mission is to provide learning experiences that are both educational and fun. We are dedicated to ensuring our clients receive what they pay for, with results that speak louder than words. We pride ourselves on offering the best, customized solutions tailored specifically to the needs of each individual.
          </p>
          <p className="text-lg text-gray-700 mb-4 leading-relaxed">
            In addition to our personalized solutions, we offer free courses and webinars led by industry experts to help learners at every stage of their journey. Whether you're looking to kickstart a new career or simply explore a new hobby, Stack is here to make your learning experience enjoyable and effective.
          </p>
        </div>
      </div>

      {/* Contact Section */}
      <div className="relative overflow-hidden bg-gray-50">
        <div className="absolute inset-0 bg-[#6c32ee] opacity-5 transform skew-y-6"></div>
        <div className="relative max-w-6xl mx-auto px-8 py-24 text-center">
          <span className="text-[#6c32ee] text-sm font-semibold tracking-wider uppercase mb-4 block">Get Started</span>
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Transform Your Business?</h2>
          <p className="text-gray-600 mb-12 max-w-2xl mx-auto text-lg leading-relaxed">
            Let's collaborate to create innovative solutions that drive your business forward.
          </p>
          <button
            onClick={() => handleContactClick(navigate, () => { })}
            className=" px-10 py-4 rounded-xl text-white font-semibold bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] transform transition-all duration-300 hover:scale-[1.02]hover:shadow-lg">
            Start a Conversation
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;